import { Grid, MenuItem, Select, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { ENABLE_RTA_APPROVER, bulkUsersType } from '../../utils/constant';
import { CommonLayout } from '../commonComponents';
import { Notes } from '../investors/components';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  amcAdminTemplate,
  amcApproverTemplate,
  amcAuthorisedSignatoryTemplate,
  companyDistributorTemplate,
  distributorRMTemplate,
  individualDistributorTemplate,
  investmentManagerTemplate,
  poaApproverTemplate,
  rmTemplate,
  rtaApproverTemplate,
  trusteeTemplate,
} from '../../redux-store/actions';
import { reportDownload } from '../Reports/report-utils';
import BulkUploadFilePond from './bulkuploadFilePond';

export default function addBulkUsers(): JSX.Element {
  const [selectedUser, setSelectedUser] = useState('download');
  const dispatch = useDispatch();
  return (
    <CommonLayout>
      <Box>
        <Typography
          sx={{
            fontFamily: 'Poppins, sans-serif',
            fontSize: 18,
            fontWeight: 500,
            mb: { xs: 2, md: 4 },
            p: { xs: '5px 15px', md: '' },
            bgcolor: '#e5f1f8',
            borderRadius: '10px',
          }}>
          Create Bulk Users
        </Typography>
        <Grid
          container
          rowSpacing={1}
          columnSpacing={10}
          sx={{
            width: '100%',
            ml: 0,
            '.MuiGrid-item': { px: { xs: 0, sm: '25%' } },
            px: '30px',
            py: '5%',
            bgcolor: 'common.white',
            mt: 1.5,
          }}>
          <Grid sx={{ width: '100%', mb: 4 }}>
            <Notes displayContent={'Please upload the template for user creation'} />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Select
              style={{
                width: '100%',
                height: '44px',
                padding: '10px 12px',
                borderRadius: '6px',
                fontSize: '15px',
              }}
              value={selectedUser}
              onChange={async ({ target: { value } }) => {
                try {
                  setSelectedUser(value);
                  switch (value) {
                    case 'rm': {
                      const res = await dispatch(rmTemplate());
                      reportDownload(res as unknown as Blob, 'rm.xlsx');
                      return;
                    }
                    case 'individual_distributor': {
                      const res = await dispatch(individualDistributorTemplate());
                      reportDownload(res as unknown as Blob, 'distributor_individual.xlsx');
                      return;
                    }
                    case 'company_distributor': {
                      const res = await dispatch(companyDistributorTemplate());
                      reportDownload(res as unknown as Blob, 'distributor_company.xlsx');
                      return;
                    }
                    case 'distributorRm': {
                      const res = await dispatch(distributorRMTemplate());
                      reportDownload(res as unknown as Blob, 'distributor_rm.xlsx');
                      return;
                    }
                    case 'amcAuthorisedSignatory': {
                      const res = await dispatch(amcAuthorisedSignatoryTemplate());
                      reportDownload(res as unknown as Blob, 'authorised_signatory.xlsx');
                      return;
                    }
                    // case 'poaApprover': {
                    //   const res = await dispatch(poaApproverTemplate());
                    //   reportDownload(res as unknown as Blob, 'poa_approver.xlsx');
                    //   return;
                    // }
                    // case 'trustee': {
                    //   const res = await dispatch(trusteeTemplate());
                    //   reportDownload(res as unknown as Blob, 'trustee.xlsx');
                    //   return;
                    // }
                    // case 'investmentManager': {
                    //   const res = await dispatch(investmentManagerTemplate());
                    //   reportDownload(res as unknown as Blob, 'investment_manager.xlsx');
                    //   return;
                    // }
                    case 'rtaApprover': {
                      const res = await dispatch(
                        ENABLE_RTA_APPROVER ? rtaApproverTemplate() : amcApproverTemplate()
                      );
                      reportDownload(res as unknown as Blob, 'pms_approver.xlsx');
                      return;
                    }
                    case 'amcApprover': {
                      const res = await dispatch(amcApproverTemplate());
                      reportDownload(res as unknown as Blob, 'amc_approver.xlsx');
                      return;
                    }
                    case 'amcAdmins': {
                      const res = await dispatch(amcAdminTemplate());
                      reportDownload(res as unknown as Blob, 'amc_admin.xlsx');
                      return;
                    }
                  }
                } catch (e) {
                  console.error((e as Error).message);
                }
              }}>
              {Object.keys(bulkUsersType).map((_user) => (
                <MenuItem value={_user} key={_user}>
                  {bulkUsersType[_user]}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={12} sm={12} mt={4}>
            <Typography
              sx={{
                display: 'block',
                padding: '0 0 5px',
                alignSelf: { xs: 'center' },
              }}>
              Bulk Upload
            </Typography>
            <Box>
              <BulkUploadFilePond bulkTemplateType={'user'} />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </CommonLayout>
  );
}
